import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Shield } from 'lucide-react';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('aerodeals_cookie_consent');
    if (!consent) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem('aerodeals_cookie_consent', 'accepted');
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('consent', 'update', {
        ad_storage: 'granted',
        ad_user_data: 'granted',
        ad_personalization: 'granted',
        analytics_storage: 'granted',
      });
    }
    setVisible(false);
  };

  const reject = () => {
    localStorage.setItem('aerodeals_cookie_consent', 'rejected');
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('consent', 'update', {
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied',
        analytics_storage: 'denied',
      });
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[60] p-4" data-testid="cookie-banner">
      <div className="max-w-4xl mx-auto bg-zinc-900 border border-zinc-800 backdrop-blur-xl p-5 sm:p-6 shadow-2xl shadow-black/50">
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <Shield size={20} className="text-[#C5A059] shrink-0 mt-0.5 sm:mt-0" />
          <div className="flex-1">
            <p className="text-sm text-zinc-300 leading-relaxed">
              AeroDeals utilizza i cookie per migliorare l'esperienza dell'utente, fornire funzionalità aggiuntive ed analizzare il traffico. Continuando a navigare sul nostro sito, acconsenti all'uso dei cookie in conformita dell'informativa.{' '}
              <Link to="/privacy" className="text-[#C5A059] hover:underline">Privacy Policy</Link>
            </p>
          </div>
          <div className="flex items-center gap-3 shrink-0">
            <button
              onClick={reject}
              className="px-4 py-2 text-xs border border-zinc-700 text-zinc-400 hover:text-white hover:border-zinc-500 transition-colors"
              data-testid="cookie-reject-btn"
            >
              Rifiuta
            </button>
            <button
              onClick={accept}
              className="px-5 py-2 text-xs bg-[#C5A059] text-black font-medium hover:bg-[#D4B271] transition-colors"
              data-testid="cookie-accept-btn"
            >
              Accetta
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
